<template>
	<div class="checkbox-wrapper" :class="{ disabled: disabled }">
		<svgicon
			:name="state"
			:class="state"
			@click="updateValue(!value)"
		></svgicon>

		<slot></slot>
	</div>
</template>
<script>
import '../icons/checkbox-deselected';
import '../icons/checkbox-selected';

export default {
	props: {
		value: {
			type: Boolean,
			value: false
		},
		label: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			value: false
		}
	},
	computed: {
		state() {
			return this.value ? 'checkbox-selected' : 'checkbox-deselected';
		}
	},
	methods: {
		updateValue(value) {
			if (!this.disabled) {
				this.$emit('input', value);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.checkbox-wrapper {
	font-family: 'RobotoRegular';
	color: $checkbox-color;
	font-size: 15px;
	line-height: 23px;
	display: inline-flex;
	align-items: center;

	&.disabled {
		color: $disabled-text-color;
		svg {
			fill: $checkbox-icon-color;
		}
	}

	svg {
		height: 24px;
		width: 24px;
		margin-right: 16px;
	}

	&:not(.disabled) {
		svg {
			fill: $checkbox-icon-color;

			&.checkbox-selected {
				fill: $icon-color;
			}

			&:hover {
				cursor: pointer;
				fill: $icon-hover;
			}
		}
	}
}
</style>
